<template>
  <b-overlay
    :show="processing"
    rounded="sm"
  >

    <template v-slot:overlay>
      <div
        v-if="processing"
        class="text-center p-4 bg-primary text-light rounded"
      >
        <b-icon
          icon="cloud-download"
          font-scale="4"
        />
        <div class="mb-3 mt-2">
          منتظر بمانید ...
        </div>
        <b-progress
          min="1"
          max="60"
          :value="counter"
          variant="success"
          height="3px"
          class="mx-n4 rounded-0"
        />
      </div>
    </template>

    <b-card
      title="مدیریت سفارش ها"
    >
      <b-row>
        <b-col
          class="table-size"
        >
          <div class="custom-search">
            <b-row>
              <div class="filter-row">
                <b-col md="2">
                  <b-form-group
                    label="خدمت"
                    label-for="DutyId"
                  >
                    <z-duty
                      v-model="filterOptions.DutyId"
                      :clearable="true"
                      :multiple="false"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group>
                    <label>وضعیت</label>
                    <v-select
                      v-model="filterOptions.Status"
                      :options="enums('OrderStatus')"
                      dir="rtl"
                      label="text"
                      :reduce="x => x.value"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group>
                    <label>پرداخت</label>
                    <v-select
                      v-model="filterOptions.IsPaid"
                      :options="enums('IsPaid')"
                      dir="rtl"
                      label="text"
                      :reduce="x => x.value"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group
                    label="از تاریخ"
                    label-for="FromDate"
                  >
                    <date-picker
                      v-model="filterOptions.FromDate"
                      placeholder=""
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group
                    label="تا تاریخ"
                    label-for="FromDate"
                  >
                    <date-picker
                      v-model="filterOptions.ToDate"
                      placeholder=""
                    />
                  </b-form-group>
                </b-col>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
                >فیلتر
                </b-button>
              </div>
            </b-row>
          </div>

          <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :no-local-sorting="true"
            :sort-by="filterOptions.SortBy"
            :sort-desc="filterOptions.IsDesc"
            :busy="loading"
            @sort-changed="sortChange"
          >
            <template #cell(Id)="data">
              <b-link
                :to="{ name: 'updatedutyorder', params: { id: data.value }}"
                class="font-weight-bold"
              >
                #{{ data.value }}
              </b-link>
            </template>

            <template #cell(User)="data">
              <b-link>
                <b-media
                  vertical-align="center"
                  style="align-items: center;"
                >
                  <template #aside>
                    <b-avatar
                      :src="data.value.Image"
                    />
                  </template>
                  <span
                    class="font-weight-bold d-block text-nowrap"
                    style="color: #6e6b7b;"
                  >
                    {{ data.item.Name }} {{ data.item.Family }}
                  </span>
                  <!--                  <small class="text-muted">{{ data.value.Id }}</small>-->
                </b-media>
              </b-link>
            </template>

            <template #cell(IsPaid)="data">
              <b-badge
                v-if="data.item.IsPaid"
                variant="light-success"
              >
                پرداخت شده
              </b-badge>
              <b-badge
                v-else
                variant="light-warning"
                @click="showModal(data.item)"
              >
                پرداخت نشده
              </b-badge>
            </template>

            <template #cell(Status)="data">
              <b-badge
                v-if="data.item.Status !== null"
                :variant="enums('OrderStatus', 'value', data.value, 'badge')"
                @click="openSidebar(data.item)"
              >
                {{ enums('OrderStatus', 'value', data.value, 'text') }}
              </b-badge>
            </template>

            <template #cell(CreatedAt)="data">
              {{ data.item.CreatedAt | date }}
            </template>

            <template #cell(Price)="data">
              {{ data.value | price }}
            </template>

            <template #cell(actions)="data">

              <div
                class="text-nowrap"
              >
                <b-link :to="{ name: 'updatedutyorder', params: { id: data.item.Id }}">
                  <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                  />
                </b-link>

                <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.Id)"
                />
              </div>
            </template>

            <template #table-busy>
              <div
                class="text-center my-2"
              >
                <b-spinner
                  variant="primary"
                  class="align-middle"
                />
                <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
              </div>
            </template>

          </b-table>

          <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
          />

        </b-col>

      </b-row>

    </b-card>

  </b-overlay>
</template>

<script>

import { BIcon, BIconCloudDownload } from 'bootstrap-vue'
import ZDietDuration from '@/tools/dietduration.vue'
import ZCoupon from '@/tools/coupon.vue'
import ZUserDietOrderDetails from '@/views/menu/order/userdietorderdetails.vue'
import ZProduct from '@/tools/product.vue'
import ZDuty from '@/tools/duty.vue'

export default {
  name: 'Order',
  components: {
    ZDuty,
    ZProduct,
    ZDietDuration,
    ZCoupon,
    ZUserDietOrderDetails,
    BIcon,
    BIconCloudDownload,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      processing: false,
      counter: 1,
      isShow: false,
      row: null,
      filterOptions: {
        Title: null,
        Page: 1,
        SortBy: 'Id',
        IsDesc: true,
        IsPaid: true,
        Bank: null,
        CouponId: null,
        FromDate: this.$moment().startOf('jMonth').format('YYYY/MM/DD'),
        ToDate: this.$moment().endOf('jMonth').format('YYYY/MM/DD'),
      },
      isSidebarOpen: false,
      userDietOrderDetails: {
        DietDurationPrice: { Diet: {}, DietDuration: {} },
        Coupon: {},
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        // {
        //     key: 'DietDurationPrice',
        //     label: 'محصول',
        // },
        {
          key: 'User',
          label: 'کاربر',
        },
        // {
        //     key: 'Code',
        //     label: 'کد پیگیری',
        //     tdClass: 'col-width-15',
        // },
        {
          key: 'Price',
          label: 'مبلغ',
          sortable: true,
        },
        // {
        //   key: 'OrderCoupon',
        //   label: 'کپن',
        // },
        // {
        //   key: 'Shipping',
        //   label: 'ارسال',
        // },
        // {
        //   key: 'Bank',
        //   label: 'بانک',
        // },
        {
          key: 'CreatedAt',
          label: 'تاریخ',
          sortable: true,
        },
        {
          key: 'IsPaid',
          label: 'پرداخت',
        },
        {
          key: 'Status',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.dutyorder.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    openSidebar(data) {
      this.isSidebarOpen = true
      this.userDietOrderDetails = data
    },
    remove(id) {
      this.removeRow(this.$api.discount.remove, 'Id', id)
    },
  },
}
</script>
